import { useAtomValue } from 'jotai';
import { endOfDay } from 'date-fns';
import { trackingByCompanyIdStateJ } from '../../../services/state/ListsStateJ';

export function useTrackingData(companyId: number) {
  const trackingByCompanyId = useAtomValue(trackingByCompanyIdStateJ);
  const trackingData = trackingByCompanyId.get(companyId);
  const hasExpired = trackingData?.snoozeDate
    ? endOfDay(new Date(trackingData.snoozeDate)) < new Date()
    : false;

  return { hasExpired, snoozeDate: trackingData?.snoozeDate };
}
